const BASE_URL = "/stablecoins";

export const PAGE_URLS = {
  onboarding: `${BASE_URL}/onboarding`,
} as const;
